import { Box, styled, Typography } from '@mui/material';

export const TypographyStyled = styled(Typography)(({ theme }) => ({
  fontSize: '14px',
  fontWeight: 500,
  color: theme.palette.colors.onSecondaryAndDetailBackground,
  marginRight: theme.spacing(),
}));

export const BoxStyled = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isVisible',
})(({ isVisible }) => ({
  visibility: isVisible ? 'visible' : 'hidden',
  position: 'relative',
}));

export const Wrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'hasHeader' && prop !== 'isDashboard',
})(({ theme, hasHeader, isDashboard }) => ({
  height: isDashboard ? 'auto' : '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  margin: hasHeader ? '24px 0 0 0' : 0,
  border: hasHeader && `solid 1px ${theme.palette.colors.borderLine}`,
  borderRadius: 5,
  backgroundColor: isDashboard
    ? theme.palette.colors.secondaryBackground
    : theme.palette.colors.primaryBackground,
  padding: hasHeader ? '20px 20px 0' : '24px 64.5px 0',
  [theme.breakpoints.down('xxl')]: {
    padding: '24px 24px 0',
  },
  [theme.breakpoints.down('xl')]: {
    padding: '24px 16px 0',
  },
  [theme.breakpoints.down('lg')]: {
    width: '600px',
    margin: 0,
    marginBottom: 8,
    padding: '16px 40px 0',
  },
  [theme.breakpoints.down('md')]: {
    width: '344px',
    margin: 0,
    marginBottom: 8,
    padding: '16px 16px 0',
  },
}));

export const InvisibleOverlayContainer = styled(Box)(() => ({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
}));
